import AdvertisingMediaMasterPage from './AdvertisingMediaMasterPage';

export default AdvertisingMediaMasterPage;
